import React from 'react';
import { useHistory } from 'react-router-dom';
import { Nav } from '@fluentui/react';

const navLinkGroups = [
  {
    links: [
      {
        key: 'admins',
        name: 'Administrators',
        path: '/admins',
      },
      {
        key: 'users',
        name: 'Users',
        path: '/users',
      },
      {
        key: 'algos',
        name: 'Algos',
        path: '/algos',
      },
      {
        key: 'jobs',
        name: 'Jobs',
        path: '/jobs',
      },
      {
        key: 'manage-instance',
        name: 'Manage Instance',
        path: '/manage-instance',
      },
      {
        key: 'documents-topics',
        name: 'Documents',
        path: '/document-topics',
      },
      {
        key: 'notification-monitoring',
        name: 'Notification Monitoring',
        path: '/notification-monitoring',
      },
    ],
  },
  {
    name: 'Announcements',
    links: [
      {
        key: 'announcements',
        name: 'In-app Announcement',
        path: '/announcements/in-app-announcements',
      },
      {
        key: 'telegram-alerts',
        name: 'Telegram Alerts',
        path: '/announcements/telegram-alerts?jobName=send-notification',
      },
    ],
  },
  {
    name: 'System',
    links: [
      {
        key: 'config',
        name: 'Config',
        path: '/system/config',
      },
      {
        key: 'master-contracts',
        name: 'Master Contracts',
        path: '/system/master-contracts',
      },
      {
        key: 'holidays',
        name: 'Holidays',
        path: '/system/holidays',
      },
      {
        key: 'expiry-dates',
        name: 'Expiry Dates',
        path: '/system/expiry-dates',
      },
      {
        key: 'broker-settings',
        name: 'Broker Settings',
        path: '/system/broker-settings',
      },
    ],
  },
];

const getCurruntRoute = (history, navRoutes) => {
  let targetRoute = {};

  const pathname = history?.location?.pathname;

  if (pathname) {
    for (let nr = 0; nr < navRoutes.length; nr++) {
      const { links = [] } = navRoutes[nr];

      const linkFound = links.find((nrl) => {
        if (!nrl.path) return false;

        // remove query params from nav path
        const basePath = nrl.path.split('?')[0];

        return pathname.startsWith(basePath);
      });

      if (linkFound?.key) {
        targetRoute = linkFound;
        break;
      }
    }
  }

  return targetRoute;
};

// eslint-disable-next-line react/display-name
export default function () {
  const history = useHistory();
  const { key: selectedKey = null } = getCurruntRoute(history, navLinkGroups);

  console.log('debug:', selectedKey);

  return (
    <Nav
      onLinkClick={(e, item) =>
        history.push(item.path, {
          source: 'drawer',
        })
      }
      groups={navLinkGroups}
      selectedKey={selectedKey}
    />
  );
}
